module.exports = __webpack_public_path__ + "img/constrBanner.d5b65619.png";